// I have no idea what this is meant to be as it's used as a component elsewhere
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SVG = ({ children, ...rest }) => {
    return {
        svg: children,
        ...rest
    };
};
export default SVG;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU1ZHLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbXBvbmVudHMvU1ZHLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxnRkFBZ0Y7QUFDaEYsOERBQThEO0FBQzlELE1BQU0sR0FBRyxHQUFHLENBQUMsRUFBRSxRQUFRLEVBQUUsR0FBRyxJQUFJLEVBQWtCLEVBQU8sRUFBRTtJQUN6RCxPQUFPO1FBQ0wsR0FBRyxFQUFFLFFBQVE7UUFDYixHQUFHLElBQUk7S0FDUixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxHQUFHLENBQUMifQ==